import { zendeskHttpRequest } from "../zendeskHttpRequest.ts";

export const deleteArticleAttachment = async (
  token: string,
  brandUrl: string,
  articleAttachmentId: number,
) => {
  await zendeskHttpRequest(
    `help_center/articles/attachments/${articleAttachmentId}`,
    token,
    "DELETE",
    brandUrl,
  );
};
